import clsx from 'clsx';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { DpRequest } from '../../../../../shared/dpRequests';
import { REQUEST_TYPE_LABELS, describeRequestStatus } from '../../dpRequests.definitions';
import { StatusPill } from '../StatusPill';
import type { MyRequestsSectionProps } from './myRequestsSection.types';

function requestTitle(request: DpRequest): string {
    if (request.type === 'ticket') {
        return request.category === 'reserved' ? 'Chamado reservado' : request.subject;
    }
    return REQUEST_TYPE_LABELS[request.type];
}

function formatDate(request: DpRequest): string {
    return request.createdAt.toDate().toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function MyRequestsSection({ requests, onOpen, limit = 10 }: MyRequestsSectionProps) {
    if (requests.length === 0) {
        return (
            <p className="rounded-2xl border border-dashed border-raro-gray-200 px-5 py-8 text-center text-sm text-raro-gray-500">
                Você ainda não fez pedidos ao DP.
            </p>
        );
    }

    const visible = requests.slice(0, limit);

    return (
        <section aria-labelledby="my-dp-requests" className="space-y-3">
            <h2 id="my-dp-requests" className="font-montserrat text-base font-semibold text-raro-gray-900">Meus pedidos</h2>
            <ul className="overflow-hidden rounded-2xl border border-raro-gray-200 bg-white shadow-sm divide-y divide-raro-gray-100">
                {visible.map(request => {
                    const meta = describeRequestStatus(request);
                    return (
                        <li key={request.id}>
                            <button
                                type="button"
                                onClick={() => onOpen(request.id)}
                                className={clsx(
                                    'flex w-full items-center gap-4 px-4 py-3.5 text-left transition hover:bg-primary-50/60',
                                    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-inset focus-visible:outline-primary-500'
                                )}
                            >
                                <span className="min-w-0 flex-1">
                                    <span className="block truncate text-sm font-semibold text-raro-gray-900">{requestTitle(request)}</span>
                                    <span className="mt-0.5 block text-xs text-raro-gray-500">
                                        {REQUEST_TYPE_LABELS[request.type]} · {formatDate(request)}
                                    </span>
                                </span>
                                <StatusPill label={meta.label} tone={meta.tone} className="hidden sm:inline-flex" />
                                <ChevronRightIcon className="h-4 w-4 shrink-0 text-raro-gray-400" aria-hidden="true" />
                            </button>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}
